import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';
import myGlobals = require('../config');

@Injectable()
export class LogActividadService {

    private informeUrl = myGlobals.default.BASE_URL + '/logActividad';  // URL to web api

    constructor(private http: Http) {
    }

    // Informe resumen
    public export(filtros: any): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/pdf'
        });
        headers.append('dataType', 'json');
        var esc = encodeURIComponent;
        var query = "";
        if (filtros)
            query = Object.keys(filtros)
                .map(k => esc(k) + '=' + esc(filtros[k]))
                .join('&');
        let requestOptions = {headers: headers, responseType: 'arraybuffer'};
        return this.http
            .get(this.informeUrl + "/export?" + query, requestOptions)
            .map((response) => {
                const linkSource = `data:application/pdf;base64,${response.text()}`;
                const downloadLink = document.createElement("a");
                const fileName = "reporteActividadesBemakoha" + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/logActividad/logActividad.service.ts